import moment from 'moment'
import React from 'react'

export default function ModalInitiative({
    days,
  setok4,
  t,
  respect_note,  initiative,
}) {
  return (
    <div
      className="modal fade"
      id="initiative"
      data-backdrop="static"
      data-keyboard="false"
      tabIndex={-1}
      role="dialog"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="initiative">
              Note d'initiative : du {moment(days).format("DD/MM/YYYY")}
            </h5>
            <span>
              <i
                className="icon icon-close text-azure"
                style={{ cursor: "pointer" }}
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setok4(false)}
              />{" "}
            </span>
          </div>

          <div className="modal-body">
            <table className="table  ">
              <thead>
                <tr>
                  <th>Critéres </th>
                  <th className="text-center">Total</th>
                  <th className="text-center">Note</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Notes </td>
                  <td className="text-center">
                    {respect_note[days]!== undefined? respect_note[days][0]?.total_note : "-"}
                  </td>
                  <td className="text-center">
                    {respect_note[days]!== undefined? respect_note[days][0]?.respect_note :"-"}
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={4}>
                    Note Total : <b>{initiative(days,respect_note)}/1</b>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-yellow"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setok4(false)}
            >
              <i className=" ti-close mr-1" /> {t("dashboard.Fermer")}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
